export default __webpack_public_path__ + "static/media/drdo_client.3d790a68.png";